document.addEventListener('DOMContentLoaded', function () {
  // Prüfe, ob Body die Klasse hat
//   if (!document.body.classList.contains('single-landingpage')) {
//       return; // Nicht auf dieser Seite ausführen
//   }

  const popupOuter = document.querySelector('.intent--exit--outer');
  const closeButton = document.querySelector('.close-intent');
  
  if (!popupOuter || !closeButton) {
      return; // Elemente nicht gefunden
  }

  // Session-Prüfung: Popup nur einmal pro Session anzeigen
  if (sessionStorage.getItem('exitIntentShown')) {
      return;
  }

  // Exit Intent Detection
  document.addEventListener('mouseout', function (e) {
      if (e.clientY < 10 && !sessionStorage.getItem('exitIntentShown')) { // Maus verlässt oben
          popupOuter.classList.add('active');
          sessionStorage.setItem('exitIntentShown', 'true'); // Markiere als gezeigt
      }
  });

  // Schließen per Button
  closeButton.addEventListener('click', function () {
      popupOuter.classList.remove('active');
      sessionStorage.setItem('exitIntentShown', 'true'); // Verhindere Wiedererscheinen
  });

  // Optional: Schließen per ESC-Taste
  document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popupOuter.classList.contains('active')) {
          popupOuter.classList.remove('active');
          sessionStorage.setItem('exitIntentShown', 'true'); // Verhindere Wiedererscheinen
      }
  });
});